import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Common/Button';
import { Search, MessageSquarePlus, MapPin, Filter, Grid3x3, Heart } from 'lucide-react';

const UeberUns = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          {/* Mobile: Nur Logo-Text */}
          <h1 className="hero-title-mobile">
            grosskinder-aktiv.ch
          </h1>
          
          {/* Desktop: Voller Titel und Untertitel */}
          <h1 className="hero-title">
            Ueber uns
          </h1>
          <p className="hero-subtitle">
            Wir verbinden Familien mit passenden Freizeitangeboten in Winterthur und Umgebung
          </p>

          {/* Main Action Buttons */}
          <div className="hero-actions">
            <Button
              size="lg"
              className="primary-action"
              onClick={() => navigate('/')}
            >
              <Search className="icon-mr" size={20} />
              Aktivitäten finden
            </Button>
            
            <Button
              size="lg"
              variant="outline"
              className="secondary-action"
              onClick={() => navigate('/activities/new')}
            >
              <MessageSquarePlus className="icon-mr" size={20} />
              Aktivität mitteilen
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="scroll-indicator">
            <p className="scroll-text">Mehr erfahren</p>
            <svg
              className="scroll-arrow"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="about-section">
        <div className="about-container">
          <h2 className="section-title">
            Über dieses Projekt
          </h2>
          
          <div className="about-grid">
            <div className="about-card">
              <div className="card-icon">
                <Search size={24} />
              </div>
              <h3 className="card-title">Was wir bieten</h3>
              <p className="card-text">
                Eine umfassende Plattform zur Entdeckung von Freizeitaktivitäten für Kinder in Winterthur und Umgebung. 
                Mit intelligenten Filtern nach Alter, Kosten und Fahrzeit finden Sie passende Aktivitäten – inklusive 
                direkter ÖV-Routenplanung ab Ihrem Wohnort.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon">
                <Heart size={24} />
              </div>
              <h3 className="card-title">Unsere Mission</h3>
              <p className="card-text">
                Wir möchten Grosseltern, Eltern und Betreuungspersonen dabei unterstützen, qualitativ hochwertige und 
                altersgerechte Freizeitangebote in der Nähe von Winterthur zu finden. Unser Ziel ist es, Grosskindern unvergessliche Erlebnisse 
                zu ermöglichen und Familien zu inspirieren.
              </p>
            </div>
          </div>

          {/* Features */}
          <h3 className="features-title">Funktionen</h3>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">
                <Filter size={32} />
              </div>
              <h4 className="feature-title">Umfangreiche Filter</h4>
              <p className="feature-text">
                Filtern Sie nach Alter, Entfernung, Wetter, Kosten und vielem mehr
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <MapPin size={32} />
              </div>
              <h4 className="feature-title">Kartenansicht</h4>
              <p className="feature-text">
                Visualisieren Sie den Weg zu den Aktivitäten auf Google Maps mit direkter Routenplanung
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Grid3x3 size={32} />
              </div>
              <h4 className="feature-title">Übersichtliche Darstellung</h4>
              <p className="feature-text">
                Navigieren Sie durch eine benutzerfreundliche Oberfläche mit klaren Kategorien und Empfehlungen
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="cta-section">
            <Button
              size="lg"
              className="cta-button"
              onClick={() => navigate('/')}
            >
              Jetzt Aktivitäten entdecken
            </Button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default UeberUns;
